import { createAsyncThunk } from '@reduxjs/toolkit';
import { SecureClient, debug, APP_ID, APP_VERSION } from '../../../../utils';

export const DynamicTileApi = createAsyncThunk(
  'DynamicTileApi',
  async (dynamicTilePayload, { dispatch }) => {
    dispatch({ type: 'DynamicTileApi/pending', payload: {} });

    const { customerId, Authorization, customerRefNum } = dynamicTilePayload;
    SecureClient({
      isEncrypted: true,
      customerId,
      otherPayloadDetailsPresent: true,
      route: 'customerdashboard/dynamic_dashboard',
      payload: {
        customerRefNum,
        appId: APP_ID,
        appVersion: APP_VERSION,
      },
      headers: { Authorization },
      method: 'POST',
      successFn: (res) => {
        debug('WATCH', `Response: `, res);
        const dynamicTileResp = res;
        dispatch({
          type: 'DynamicTileApi/fulfilled',
          payload: dynamicTileResp,
        });
      },
      errorFn: (err) => {
        debug('ERROR', `Error: `, err);
        dispatch({ type: 'DynamicTileApi/rejected', payload: err });
      },
    });
  }
);

export const DynamicTileApi_extrareducer = {
  [DynamicTileApi.pending]: (state, action) => {
    state.dynamicTileApiState.isLoading = true;
  },
  [DynamicTileApi.fulfilled]: (state, action) => {
    state.dynamicTileApiState.isLoading = false;
    state.dynamicTileApiState.isSuccess = true;
    state.dynamicTileApiState.isError = false;
    state.dynamicTileApiState.response = action.payload;
  },
  [DynamicTileApi.rejected]: (state, action) => {
    state.dynamicTileApiState.isLoading = false;
    state.dynamicTileApiState.isSuccess = false;
    state.dynamicTileApiState.isError = true;
    state.dynamicTileApiState.response = action.payload;
  },
};
